import double11 from './source/double11';
export default [
    double11,
]